import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { RADAR } from "@/content/site";
import { Container, Eyebrow, Body, ArrowLink, Reveal } from "@/components/site/ui";
import RadarItem from "@/components/site/RadarItem";

export const useRadar = (limit) =>
    useQuery({
        queryKey: ["radar", limit],
        queryFn: async () => (await api.get("/radar", { params: { limit } })).data,
        staleTime: 60_000,
    });

// Oculto enquanto não houver leituras publicadas.
const RadarPreview = () => {
    const { data } = useRadar(3);
    if (!data || data.length === 0) return null;
    return (
        <section id="radar" data-testid="home-radar" data-section-id="radar" className="relative bg-[#0E2018] py-24 md:py-32">
            <Container className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                <Reveal className="lg:col-span-4">
                    <Eyebrow>{RADAR.eyebrow}</Eyebrow>
                    <p className="font-serif font-light text-[24px] md:text-[28px] leading-[1.3] text-[#F2EFE5] text-balance">{RADAR.lead}</p>
                    <Body className="mt-6 !text-[13.5px]">{RADAR.aviso}</Body>
                    <div className="mt-10">
                        <ArrowLink to="/radar" testId="home-radar-link">Abrir o Radar</ArrowLink>
                    </div>
                </Reveal>
                <Reveal className="lg:col-span-8" delay={150}>
                    {data.map((it) => <RadarItem key={it.id} item={it} />)}
                </Reveal>
            </Container>
        </section>
    );
};

export default RadarPreview;
